<template lang="html">
  <div id="blog-page">

    <section class="container med-container articles-section">
      <div class="row">
        <div class="col-12 col-title-s1">
          <h3 class="title">Tutoriales</h3>
        </div>

        <!-- <div class="col-12 col-form">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                v-model="formSearch.keywords"
                type="text"
                placeholder="Buscar artículo..."
                required
              ></b-form-input>
            </b-form-group>
            <b-button type="submit" class="btn-search"><i class="fal fa-search"></i></b-button>
          </b-form>
        </div> -->

        <div class="col-sm-6 col-lg-4 col-article-sample-1">
          <router-link class="box-article" to="/tutoriales/1">
            <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/comunicados/blog-1.jpg)' }">
              <img src="public/images/shared/empty.png">
            </div>

            <div class="box-descr">
              <h5 class="mb-1">Título de tutorial con un ejemplo, mini descripción y una imagen.</h5>

              <div class="descr">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magn.
                </p>
              </div>
            </div>
          </router-link>
        </div>

        <div class="col-sm-6 col-lg-4 col-article-sample-1" v-for="(x, baInx) in 8" :key="'ba-'+baInx">
          <router-link class="box-article" to="/tutoriales/1">
            <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/comunicados/blog-2.jpg)' }">
              <img src="public/images/shared/empty.png">
            </div>

            <div class="box-descr">
              <h5 class="mb-1">Título de tutorial con un ejemplo, mini descripción y una imagen.</h5>

              <div class="descr">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magn.
                </p>
              </div>
            </div>
          </router-link>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-pagination-sample-1">
          <b-pagination-nav :link-gen="linkGen" :number-of-pages="10" use-router></b-pagination-nav>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      formSearch: {
        keywords: null
      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },

    linkGen(pageNum) {
      return {
        name: 'tutoPage',
        query: { keywords: this.$route.query.keywords, page: pageNum }
      }
    }
  }
}
</script>
